import * as React from "react";
import { App as AntdApp } from "antd";
import { MemoryRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../../components/Login";
import ProtectedRoute from "../../components/ProtectedRoute";
import "../../styles/globals.css";
import PresentationContainer from "./PresentationContainer";

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  return (
    <AntdApp>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute authenticatedElement={<PresentationContainer />} isPopup={true} />} />
        </Routes>
      </Router>
    </AntdApp>
  );
};

export default App;
